<div class="inventory-modal">
  <div class="inventory-modal__header">
    <span class="inventory-modal__title" *ngIf="isInventory==true && isCreateNew==true">{{'Quick Frame Setup ' |
      translate | async}} </span>
    <span class="inventory-modal__title" *ngIf="isInventory==true && isCreateNew==false">{{'Frame Undercarriage Rebuild Centre' | translate |
      async}} </span>


    <i class="material-icons inventory-modal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <!-- <div class="center" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div> -->

  <div>
    <label *ngIf="isCreateNew==false">
      <input type="radio" name="alignment" value="1" [(ngModel)]="selectedFrameSide" (change)="showSelectedSide(1)">
      {{'Left' | translate | async}}
    </label>
    <label *ngIf="isCreateNew==false">
      <input type="radio" name="alignment" value="2" [(ngModel)]="selectedFrameSide" (change)="showSelectedSide(2)">
      {{'Right' | translate | async}}
    </label>
    <label *ngIf="isCreateNew==false">
      <input type="radio" name="alignment" value="3" [(ngModel)]="selectedFrameSide" (change)="showSelectedSide(3)">
      {{'Both' | translate | async}}
    </label>
  </div>


  <div *ngIf="selectedFrameSide>0">


    <div class="inventory-modal__body">

      <div class="body">


        <mat-form-field class="search-input" *ngIf="isInventory==true && isCreateNew==false">
          <mat-select (selectionChange)="customerChanged($event)" name="customer" placeholder="{{Translate('Select Customer')}}">
            <mat-option *ngFor="let customer of _dropDownLists.customerList" [value]="customer">
              {{ customer.Title }}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field class="search-input" *ngIf="isInventory==true && isCreateNew==false">
          <mat-select (selectionChange)="jobsiteChanged($event)" [(value)]="selectedJobsite" name="jobsite"
            placeholder="{{Translate('Select Job Site')}}">
            <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
              {{ jobsite.Title }}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field class="search-input" *ngIf="isInventory==true && isCreateNew==false">
          <mat-select (selectionChange)="makeChanged($event)" [(value)]="selectedMake" name="make"
            placeholder="{{Translate('Select Make')}}">
            <mat-option>None</mat-option>
            <mat-option *ngFor="let make of _dropDownLists.makeList" [value]="make">
              {{ make.Title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="search-input" *ngIf="isInventory==true && isCreateNew==false">
          <input type="text" placeholder="Model" (input)="changeModelAutoComplete($event)" matInput
            [matAutocomplete]="auto">
          <mat-autocomplete [(ngModel)]="modelTitle" #model_auto="ngModel" #auto="matAutocomplete"
            (optionSelected)="modelselect($event.option.value)">
            <mat-option [value]="model.Name" *ngFor="let model of modelList">
              {{model.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <div class="item-align-end" *ngIf="isInventory==true && isCreateNew==false"
          style="justify-content: flex-start;margin-bottom: 3%;">
          <button mat-raised-button (click)="LoadFrames()" mat-raised-button color="warn">Search Frames </button>
        </div>

        <mat-spinner class="loading-spinner mat-progress-spinner" style="align-self: center;"
          *ngIf="LoadingSpinner==true"></mat-spinner>

        <div style="display: flex; flex-direction: column;" *ngIf="filteredSystems!=null">

          <mat-form-field class="search-input"
            *ngIf="isInventory==true && isCreateNew==false && (selectedFrameSide==3 || selectedFrameSide==1)">
            <mat-select placeholder="Select a Frame Left Side" [(ngModel)]="selectedFrameLSide" name="system"
              (selectionChange)="ChangeSystemL()">
              <mat-option *ngFor="let system of frameSystemsL" [value]="system.SystemId">
                {{system.SerialNumber}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="search-input"
            *ngIf="isInventory==true && isCreateNew==false && (selectedFrameSide==3 || selectedFrameSide==2)">
            <mat-select placeholder="Select a Frame Right Side" [(ngModel)]="selectedFrameRSide" name="system"
              (selectionChange)="ChangeSystemR()">
              <mat-option *ngFor="let system of frameSystemsR" [value]="system.SystemId">
                {{system.SerialNumber}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <!-- frame information Create new -->


        <!-- <mat-form-field class="search-input" *ngIf="isInventory==false">
        <mat-select  placeholder="Select a Frame Left Side"  [(ngModel)]="selectedFrameLSide" name="system">
          <mat-option *ngFor="let system of componentList" [value]="system.CompartId">
            {{system.Name}} 
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="search-input" *ngIf="isInventory==false">
        <mat-select  placeholder="Select a Frame Right Side"  [(ngModel)]="selectedFrameRSide" name="system">
          <mat-option  *ngFor="let system of componentList_" [value]="system.CompartId" >
            {{system.Name}} 
          </mat-option>
        </mat-select>
      </mat-form-field> -->
        <div style="flex: 1">

          <mat-form-field class="input-full-width" style="width: 49%;"
            *ngIf="isInventory==true  && isCreateNew==true && (selectedFrameSide==3 || selectedFrameSide==1)">
            <input matInput placeholder="Select a Frame Left Side" [(ngModel)]="selected_frame_L"
              (change)="checkSerialNoLeft($event)">
          </mat-form-field>


          <mat-form-field class="input-full-width" style="width: 49%;"
            *ngIf="isInventory==true  && isCreateNew==true && (selectedFrameSide==3 || selectedFrameSide==2)">
            <input matInput placeholder="Select a Frame Right Side" [(ngModel)]="selected_frame_R"
              (change)="checkSerialNoRight($event)">
          </mat-form-field>


        </div>
        <!-- end frame information Create new -->

        <div style="flex: 1">

          <mat-form-field class="input-full-width" style="width: 49%;"
            *ngIf="(selectedFrameSide==3 || selectedFrameSide==1)">
            <input (focusout)="getCustomerFrameNoLeft($event)" matInput placeholder="Enter Customer Frame # Left Side"
              [(ngModel)]="selected_customerFrameLeft">
          </mat-form-field>

          <mat-form-field class="input-full-width" style="width: 49%;"
            *ngIf="(selectedFrameSide==3 || selectedFrameSide==2)">
            <input (focusout)="getCustomerFrameNoRight($event)" matInput placeholder="Enter Customer Frame # Right Side"
              [(ngModel)]="selected_customerFrameRight">
          </mat-form-field>

        </div>
        <mat-form-field>
          <input matInput #start_Date="ngModel" [(ngModel)]="selected_date" [matDatepicker]="picker"
            placeholder="Choose a date" (focusout)="getDate($event)">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>



        <mat-form-field class="input-full-width">
          <input (focusout)="getCustomerReference($event)" matInput
            placeholder="{{ 'Customer Reference' | translate | async }}" [(ngModel)]="selected_customerRef">
        </mat-form-field>
      </div>

      <div class="flex-horizontal set-margin">

        <mat-form-field class="input-full-width">
          <input (focusout)="getJobNumber($event)" matInput placeholder="{{ 'Job Number' | translate | async }}"
            [(ngModel)]="selected_jobNumber">
        </mat-form-field>

        <mat-form-field class="input-full-width ">
          <input (focusout)="getOldJobNumber($event)" matInput placeholder="{{ 'Old Job No.' | translate | async }}"
            [(ngModel)]="selected_oldJobNo">
        </mat-form-field>


      </div>
    </div>

    <div class="item-align-end">
      <button mat-raised-button color="warn" (click)="onClickStartInspection()">{{'Start Inspection' | translate | async}}</button>
    </div>
  </div>
</div>